import { Spinner } from "@biblioteksentralen/react";
import { DialogLC } from "../../../../components/ModalContainer";
import { useTranslation } from "../../../../utils/hooks/useTranslation";

type Props = { isOpen: boolean; handleClose: () => void };

export const LoadingModal = (props: Props) => {
  const { t } = useTranslation();
  return (
    <DialogLC
      modalContentProps={{ height: "18rem" }}
      heading={t("Reserver")}
      open={props.isOpen}
      onOpenChange={props.handleClose}
      hideCloseButton
    >
      <Spinner position="absolute" top="calc(50% - 1rem)" left="calc(50% - 0.5rem)" transform="translate(-50%, -50%)" />
    </DialogLC>
  );
};
